module.exports = __webpack_public_path__ + "img/full0-min.ca54495d.png";